/* eslint-disable space-before-blocks */
/* eslint-disable no-undef */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable quotes */
/* eslint-disable no-tabs */
/* eslint-disable no-console */
/* eslint-disable padded-blocks */
/* eslint-disable space-before-function-paren */
/* eslint-disable semi */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable indent */


if (!customElements.get('fostr-newsletter-component-popup')) {
    customElements.define('fostr-newsletter-component-popup', class NewsletterSignupModal extends HTMLElement {
        constructor() {
            super()

            this.dataModal = this.getAttribute('data-modal');

        }


        // https://www.victoriabeckham.com/tools/newsletter/api?email=john12@hotmddddail.com&firstname=john&lastname=test&birthdate=1990-05-16phone=07941060798&tags=tag1&foo=bar


        connectedCallback() {




            this.newsletterModalFormTemplate = document.querySelector("#newsletter-modal-form-template");

            // Copy the nodes in the template:
            const clone = this.newsletterModalFormTemplate.content.cloneNode(true);

            // Append Node:
            this.appendChild(clone);



            this.placeholderForm = this.querySelector('#NewsletterPopupContactFooter');

            this.placeholderForm.addEventListener('submit', (event) => {

                event.preventDefault();

                const emailValue = this.placeholderForm.querySelector('#NewsletterForm--popup-placeholder-form-email').value;

                const popupFormEmailField = this.querySelector('#NewsletterPopupForm--email');

                popupFormEmailField.value = emailValue;

                console.log(emailValue);


            });

            this.errorBlock = document.getElementById("newsletterPopup-error-block");

            this.contactForm = this.querySelector("#ContactFooterPopupForm");


            window.Shopify.captcha.protect(this.contactForm);



            this.querySelector("#ContactFooterPopupForm").addEventListener("submit", (event) => {
                event.preventDefault(); // Prevent the default form submission

                this.setButtonStateLoading();

                // Get form field values
                const firstname = document.getElementById("NewsletterPopupForm--firstname").value;
                const lastname = document.getElementById("NewsletterPopupForm--lastname").value;
                const phone = document.getElementById("NewsletterPopupForm--phone").value;
                const email = document.getElementById("NewsletterPopupForm--email").value;

                const dob = document.getElementById("NewsletterPopupForm--dob").value;
                const country = document.getElementById("NewsletterPopupForm--country").value;


                if (!email || !firstname || !lastname || !phone || !dob || !country) {
                    // add error/ required html
                    console.log("error");
                    this.setButtonStateReady("Subscribe");
                    this.showErrorMessage("Please fill in all fields and accept the terms and conditions");
                    return false;
                } else {
                    this.hideErrorMessage();
                }


                // Construct URL with query parameters
                const url = `https://www.victoriabeckham.com/tools/newsletter/api?email=${encodeURIComponent(email)}&firstname=${encodeURIComponent(firstname)}&lastname=${encodeURIComponent(lastname)}&birthdate=${encodeURIComponent(dob)}&country=${encodeURIComponent(country)}&phone=${encodeURIComponent(phone)}&tags=newsletter`;

                // Fetch request to the API
                fetch(url, {
                        method: "GET",
                    })
                    .then(response => response.json())
                    .then(data => {
                        // Handle success (display a message or do something with the response)
                        console.log('Success:', data);
                        // You can update the UI with a success message if needed

                        this.setButtonStateReady("Thank you for subscribing");
                        document.getElementById("ContactFooter-success").style.display = "block";

                    })
                    .catch((error) => {
                        // Handle error (display an error message)
                        console.error('Error:', error);
                    })
                    .finally(() => {

                        this.setButtonStateReady("Thank you for subscribing");
                        document.getElementById("NewsletterPopupContactFooter-success").style.display = "block";

                    });
            });






        }

        showInputErrorMessage(inputName) {
            this.querySelector(`.newsletter-popup-error-${inputName}`).style.display = 'block';
        }

        hideInputErrorMessage(inputName) {
            this.querySelector(`.newsletter-popup-error-${inputName}`).style.display = 'none';
        }

        setButtonStateReady(message) {
            const submitButton = document.getElementById("NewsletterPopupSubscribeButton");
            submitButton.setAttribute('aria-disabled', false)
            submitButton.classList.remove('loading')

            this.querySelector('.loading-overlay__spinner').classList.add(
                'hidden',
            )

            submitButton.querySelector('span').classList.remove('hidden');
            submitButton.querySelector('span').innerHTML = message;
        }

        setButtonStateLoading() {
            const submitButton = document.getElementById("NewsletterPopupSubscribeButton");


            submitButton.setAttribute('aria-disabled', true)
            submitButton.classList.add('loading')
            this.querySelector('.loading-overlay__spinner').classList.remove(
                'hidden',
            )
            submitButton.querySelector('span').classList.add('hidden');

        }



        showErrorMessage(message) {
            this.errorBlock.innerHTML = message;
            this.errorBlock.style.display = "block";

        }

        hideErrorMessage() {
            this.errorBlock.innerHTML = "";
            this.errorBlock.style.display = "none";
        }

        hideNewsletterPopup() {
            document.body.classList.remove('overflow-hidden')
            this.removeAttribute('open')
            removeTrapFocus(this.openedBy)
            window.pauseAllMedia()
        }



        fetchAvailability(variantId) {
            let rootUrl = this.dataset.rootUrl
            if (!rootUrl.endsWith('/')) {
                rootUrl = `${rootUrl}/`
            }
            const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`

            fetch(variantSectionUrl)
                .then(response => response.text())
                .then(text => {
                    const sectionInnerHTML = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('.shopify-section')
                    this.renderPreview(sectionInnerHTML)
                })
                .catch(e => {
                    const button = this.querySelector('button')
                    if (button) button.removeEventListener('click', this.onClickRefreshList)
                    this.renderError()
                })
        }

        renderError() {
            this.innerHTML = ''
            this.appendChild(this.errorHtml)

            this.querySelector('button').addEventListener('click', this.onClickRefreshList)
        }

    })
}